import React from 'react';
import { Divider, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { COLORS } from '../constants/Colors';
import Typography from './Typography';
import './style/customer.css'
import { FormattedMessage, useIntl } from 'react-intl'

const SearchCard = (props) => {
  const { handleSerchCustomer } = props;
  const intl = useIntl();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '8px',
        backgroundColor: 'white',
        width: '100%',
      }}
    >
      <div className='d-flex flex-column justify-content-center text-left w-100'>
        <Typography
          className='py-3 px-4'
          // size="14px"
          isBold
          color={COLORS.Primary}
        >
          <FormattedMessage id="customerSearchText" defaultMessage="Search" />
        </Typography>
        <Divider className='m-0' />
        <div className='py-3 px-4'>
          <Input
            style={{
              borderRadius: "20px",
            }}
            placeholder={intl.formatMessage({ id: 'placeholderSearchCustomer', defaultMessage: 'Search Customer' })}
            allowClear
            onChange={(e) => handleSerchCustomer(e.target.value)}
            // onChange={() => //console.log('Test1',handleSerchCustomer)}
            suffix={
              <div>
                <SearchOutlined
                  style={{
                    color: 'rgba(0,0,0,.45)',
                  }}
                />
              </div>
            }
          />
        </div>

        {/* <Row
          className={`${isDesktop ? "px-5 py-4" : "px-2 py-3"} `}
          gutter={{ xs: 8, lg: 16 }}
        >
          <Col span={isDesktop ? 8 : 24}>
            <StatusInfo status={STATUS.Pending} />
            <StatusInfo status={STATUS.Pending} />
          </Col>
          <Col span={isDesktop ? 8 : 24}>
            <StatusInfo status={STATUS.Delivery} />
          </Col>
          <Col span={isDesktop ? 8 : 24}>
            <StatusInfo status={STATUS.Complete} />
          </Col>
        </Row> */}
      </div>
    </div>
  );
};

export default SearchCard;
